module.exports = __webpack_public_path__ + "main/images/shared/save-content@2x.5a9e8eceffcdce1218187bc8bf669a25.png";